import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, PUT, updateCompanyIdHeader } from '../services/index';
import { getProfile } from '../data/mock/getProfile';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import { getWorkspaceLanding } from '../data/landing';

export const useMutationLogin = () => {
    const navigate = useNavigate();
    return useMutation(
      async (payload) => {
        const endPoin = `/api/v1/authen/login`;
        const {result} = await POST(endPoin, payload);

        // ยังไม่ผ่าน 2FA — ยังไม่มี token/id ให้เก็บ ต้องออกก่อน
        // ไม่งั้นจะเขียน undefined ทับ sessionStorage แล้ว state พัง
        if (result?.needTotpSetup || result?.needTotpToken) {
          return result;
        }

        sessionStorage.setItem('id',result.id)
        sessionStorage.setItem('token',result.accessToken)
        sessionStorage.setItem('role',result.userRole)
        sessionStorage.setItem('refreshToken',result.refreshToken)
        sessionStorage.setItem('userName', result.UserName);
        
        if(result.userRole == 3){
          sessionStorage.setItem('jobType', result.JobType);
        }
        
        if(result.accessToken && sessionStorage.getItem('token')){   
          if(result.userRole == 1){
            sessionStorage.setItem('location', 'backoffice');     
            navigate('/backoffice');
          }else{
            sessionStorage.setItem('location', 'workspace');
            const companyId = result.company_Id ?? result.company_id;
            if (companyId != null && companyId !== '' && String(companyId) !== '0') {
              sessionStorage.setItem('activeCompanyId', String(companyId));
              sessionStorage.setItem('companyName', result.companyName || '');
              // สีประจำบริษัทสำหรับ sidebar (มาจาก Companies.themeColor ตอน login)
              if (result.themeColor) {
                sessionStorage.setItem('companyColor', result.themeColor);
              } else {
                sessionStorage.removeItem('companyColor');
              }
              updateCompanyIdHeader(String(companyId));
            }
            // สังกัดหลายบริษัท → ไป portal ให้เลือกก่อนว่าจะเปิดบริษัทไหนบ้าง
            // (บริษัทเดียวไม่ต้องถาม เข้าทำงานเลย)
            const companies = Array.isArray(result.companies) ? result.companies : [];
            const canUsePortal =
              String(result.userRole) === '3' && Number(result.JobType) !== 1;

            if (canUsePortal && companies.length > 1) {
              navigate('/workspace/portal');
            } else {
              navigate(getWorkspaceLanding({
                role: result.userRole,
                jobType: result.JobType,
              }));
            }
          }
        }
        
        return result;
      }
    );
};

export const useMutationRefreshToken = () => {
  return useMutation(
    async (payload) => {
      const endPoin = `/api/v1/authen/refresh-token`;
      const {result} = await POST(endPoin, payload); 
      
      sessionStorage.setItem('token',result.accessToken)
      sessionStorage.setItem('refreshToken',result.refreshToken)

      if (!result.accessToken) {
        Modal.confirm({
          title: 'Session Expired',
          content: 'Your session has expired. Please login again.',
          okText: 'OK',
          onOk: () => {
            sessionStorage.clear();
            window.location.href = '/';
          }
        });
      }
             
      // if(result.accessToken && sessionStorage.getItem('token')){        
      //   navigate('/payments');
      // }
      
      return result;
    }
  );
};

export const useFetchGetProfile= () => {
  return useQuery(["get-profile"], async () => {
    
    const { result } = getProfile
    return result.profile;
  });
};

export const useMutationUpdateAccount = () => {
  return useMutation(["updateAccount"],
    async (payload) => {
      const {body} =  payload
      const endPoin = `/api/v1/authen/update-account`
      PUT(endPoin, body);
    }
  );
};

// export const UseFetchBank = (value) => {
//   return useQuery(
//     ['getFetch'],
//     async (value) => {
//       const endpoint = `https://gateway.apikbo.com/api/v1/bank`;
//       const { result } = await POST(endpoint,);
//       //const { result } = tableBank
//       return result;
//     },
//     {
//       cacheTime: 0
//     }
//   );
// };

// export const UseFetchBank = () => {
//   return useMutation(["updateAccount"],
//     async (payload) => {
//       const {body} =  payload
//       const endPoin = `https://gateway.apikbo.com/api/v1/bank`
//       await PUT(endPoin,body);
//     }
//   );
// };
